export async function shareLink({
  title
}: {
  title: string;
}): Promise<boolean> {
  const desktop = window.innerWidth >= 1024;

  try {
    if (desktop) {
      await navigator.clipboard.writeText(window.location.href);

      return true;
    }

    if (navigator.share) {
      await navigator.share({
        title: title,
        url: window.location.href
      });
    }

    return false;
  } catch (error) {
    return false;
  }
}
